class moynatForm extends HTMLElement {
  constructor() {
    super();
    this.formType = this.dataset.formType; // check which form this is
    this.collapseFormEl = this.dataset.collapseForm; // check if form is collapsed or not
    this.initialControl = this.querySelector('.form-control--initial').firstElementChild;
    this.collapseButton = this.querySelector('.collapse-form-button');
    this.collapseClicked = false;
    this.noBlurButtons = this.querySelectorAll('.no-blur');
    this.noBlurClicked = false;
    this.allInputs = this.querySelectorAll('input');
    this.validatedControls = this.querySelectorAll('[data-validate]');
    this.submitButton = this.querySelector('.button.submit');
    this.formValid = false;

    if (this.collapseFormEl == "true"){
      this.closedHeight = (this.initialControl.offsetHeight + 2) + 'px';
      this.openHeight = this.scrollHeight + 'px';
      this.style.maxHeight = this.closedHeight;
      window.addEventListener('resize', this.resize.bind(this));
      if (this.collapseButton) {this.collapseButton.addEventListener('mousedown', this.collapseClick.bind(this))}
      if (this.noBlurButtons) {
        this.noBlurButtons.forEach(
          (button) => button.addEventListener('mousedown', this.noBlurClick.bind(this))
        );
      }
      if (this.collapseButton) {this.collapseButton.addEventListener('click', this.collapseForm.bind(this))}
    }

    if (this.initialControl) {this.initialControl.addEventListener('focus', this.initialFocus.bind(this))}
    if (this.allInputs) {this.allInputs.forEach((input) => input.addEventListener('input', this.inputChange.bind(this)))}
    if (this.validatedControls) {this.validatedControls.forEach((control) => control.addEventListener('input', this.elementValidate.bind(this)))}
    if (this.validatedControls) {this.validatedControls.forEach((control) => control.addEventListener('blur', this.elementValidate.bind(this)))}
    if (this.submitButton) {this.submitButton.addEventListener('click', this.onSubmit.bind(this))}

    setTimeout(()=> {
      this.allInputs.forEach((input) => {
        if (input.value.length > 0) {
          if (input.nextElementSibling) input.nextElementSibling.classList.add('input-filled');
        } else {
          if (input.nextElementSibling) input.nextElementSibling.classList.remove('input-filled');
        }
      });
    }, 1000);
  }

  resize() {
    if(this.collapseFormEl == "true"){
      this.closedHeight = (this.initialControl.offsetHeight + 2) + 'px';
      this.openHeight = this.scrollHeight + 'px';
      if (this.style.maxHeight != this.closedHeight) {
        this.style.maxHeight = this.openHeight;
      }
    }
  }

  initialFocus() {
    if(this.collapseFormEl == "true"){
      if (this.classList.contains('footer-newsletter-signup')) {
        this.closest('.footer__content-main').classList.add('signup-open');
      }
      this.style.maxHeight = this.openHeight;
      this.style.marginTop = '20px';
    }
  }

  inputChange(event) {
    if (event.target.value.length > 0) {
      event.target.nextElementSibling.classList.add('input-filled');
    } else {
      event.target.nextElementSibling.classList.remove('input-filled');
    }
  }

  elementValidate(e) {
    if (this.collapseClicked) return;
    if (this.noBlurClicked) return;
    this.controlValidate(e.target);
  }

  controlValidate(control) {
    const validateControl = control;
    const validateType = control.getAttribute('data-validate');
    let isInvalid = false;

    if (validateControl.hasAttribute('required') && validateControl.value == '') {
      isInvalid = 'blank';
    } else {
      switch(validateType) {
        case 'email':
          const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
          if (validateControl.value.match(emailRegex)) {
            isInvalid = false;
          } else {    
            isInvalid = true;
          }
          break;
        case 'phone':
            const phoneRegex = /^[0-9\- ]+$/;
            if (validateControl.value.match(phoneRegex)) {
              isInvalid = false;
            } else {    
              isInvalid = true;
            }
            break;
        case 'firstname':
          const firstNameRegex = /^[A-Za-z]{3,}$/;
          if (validateControl.value.match(firstNameRegex)) {
            isInvalid = false;
          } else {
            isInvalid = true;
          }
          break;

        case 'lastname':
          const lastNameRegex = /^[A-Za-z]{3,}$/;
          if (validateControl.value.match(lastNameRegex)) {
            isInvalid = false;
          } else {
            isInvalid = true;
          }
          break;

        case 'checked':
          if (validateControl.checked) {
            isInvalid = false;
          } else {    
            isInvalid = 'unchecked';
          }
          break;
      }
    }
    this.returnValidation(validateControl, isInvalid);
    return isInvalid;
  }


  returnValidation(validateControl, isInvalid) {
    let validateControlLabel = validateControl.closest('.form-control');
    if(validateControlLabel == undefined) { validateControlLabel = validateControl.nextElementSibling }
    const blankMsg = this.getAttribute('data-err-blank');
    const errorCntr = validateControlLabel.querySelector('.when-error');
    const submitBtn = this.querySelector('button[type="submit"]');

    if (isInvalid == 'blank') {
      validateControlLabel.classList.add('invalid');
      validateControl.setAttribute('aria-invalid', true);
      errorCntr.textContent = blankMsg;
      submitBtn.setAttribute('disabled', true);

    } else if (isInvalid == 'unchecked') {
      validateControlLabel.classList.add('invalid');
      validateControl.setAttribute('aria-invalid', true);
      errorCntr.textContent = errorCntr.getAttribute('data-err-msg');
      submitBtn.setAttribute('disabled', true);

    } else if (isInvalid) {
      validateControlLabel.classList.add('invalid');
      validateControl.setAttribute('aria-invalid', true);
      errorCntr.textContent = errorCntr.getAttribute('data-err-msg');
      submitBtn.setAttribute('disabled', true);

    } else {
      validateControlLabel.classList.remove('invalid');
      validateControl.removeAttribute('aria-invalid');
      errorCntr.textContent = '';
      submitBtn.removeAttribute('disabled');
    }

    if(this.collapseFormEl == "true"){
      this.resize();
    }
  }

  collapseClick() {
    this.collapseClicked = true;
  }

  noBlurClick() {
    this.noBlurClicked = true;
  }

  collapseForm() {
    if(this.collapseFormEl == "true") {
      this.collapseClicked = false;
      const firstInput = this.querySelector('input');
      let firstInputFilled = false;
      if (firstInput) {
        if (firstInput.getAttribute('type') == 'email' || firstInput.getAttribute('type') == 'text') {
          if (firstInput.nextElementSibling.classList.contains('input-filled')) {
            firstInputFilled = true;
          }
        }
      }
      if (firstInputFilled) {
        this.style.marginTop = 10;
        this.style.maxHeight = (this.initialControl.offsetHeight + 2) + 'px';
      } else {
        this.style.marginTop = 0;
        this.style.maxHeight = (this.initialControl.offsetHeight + 2) + 'px';
      }

      if (this.classList.contains('footer-newsletter-signup')) {
        setTimeout(()=> {
          this.closest('.footer__content-main').classList.remove('signup-open');
        }, 400);
      }
    }
  }

  onSubmit(e) {
    e.preventDefault();
    let isInvalid = false;

    this.validatedControls.forEach((control) => {
      let validateEach = this.controlValidate(control);
      if (validateEach != false) {
        isInvalid = true;
      }
    })

    if (!isInvalid && this.formType == "login") {

      const form = this.parentElement;
      const submitBtn = this.querySelector('button[type="submit"]');

      submitBtn.setAttribute('disabled', true);

      form.submit();

    } else if (!isInvalid && this.formType == "create_customer") {

      const form = this.parentElement;
      const submitBtn = this.querySelector('button[type="submit"]');

      submitBtn.setAttribute('disabled', true);

      form.submit();

    } else if (!isInvalid && this.formType == "reset_password") {

      const form = this.parentElement;
      const submitBtn = this.querySelector('button[type="submit"]');

      submitBtn.setAttribute('disabled', true);

      form.submit();

    } else if (!isInvalid && this.formType == "contact") {

  const submitBtn = this.querySelector('button[type="submit"]');
  submitBtn.setAttribute('disabled', true);

  const responseBlk = this.querySelector('#responseMessage');
  const failMsg = this.getAttribute('data-failure-response');
  const successMsg = this.getAttribute('data-success-response');
  const acceptMarketing = this.querySelector('#accept_marketing');

  let customer_properties = {};
  customer_properties["$email"] = this.querySelector('input.email').value;
  customer_properties["name"] = this.querySelector('input.name').value;
  customer_properties["country"] = this.querySelector('select.country').value;
  customer_properties["phone_number"] =
    this.querySelector('select.dialingcode').value +
    this.querySelector('input.phone').value;

  const langSelect = this.querySelector('select.language').value;
  if (langSelect == 'english') customer_properties["language"] = "en";
  else if (langSelect == 'francais') customer_properties["language"] = "fr";
  else if (langSelect == '中国人') customer_properties["language"] = "zh";
  else customer_properties["language"] = langSelect;

  customer_properties["subject"] = this.querySelector('select.subject').value;
  customer_properties["product_reference"] = this.querySelector('input.product').value;
  customer_properties["message"] = this.querySelector('textarea.body').value.replace(/\n/g, ' ');

  const options = {
    method: 'POST',
    body: JSON.stringify({ customer_properties })
  };

  const callAPI = async () => {
    try {
      const response = await fetch('https://moynat-scripts.netlify.app/.netlify/functions/contact-request', options);
      const data = await response.json();

      if (data == 1) {
        responseBlk.innerHTML = '<p>' + successMsg + '</p>';

        // 👇 Si la case marketing est cochée, déclenche aussi le "newsletter"
        if (acceptMarketing && acceptMarketing.checked) {
          const newsletterData = {
            email: customer_properties["$email"],
            first_name: customer_properties["name"],
            language: customer_properties["language"]
          };
          await fetch('https://moynat-scripts.netlify.app/.netlify/functions/new-signup', {
            method: 'POST',
            body: JSON.stringify({ customer_properties: newsletterData })
          });
          console.log("Newsletter signup triggered for:", newsletterData.email);
        }

      } else {
        responseBlk.innerHTML = '<p>' + failMsg + '</p>';
        submitBtn.disabled = false;
      }
    } catch (e) {
      console.error(e);
      responseBlk.innerHTML = '<p>' + failMsg + '</p>';
      submitBtn.disabled = false;
    }
  };

  callAPI();
  
} else if (!isInvalid && this.formType == "newsletter") {
      
      const submitBtn = this.querySelector('button[type="submit"]');
      submitBtn.setAttribute('disabled', true);

      let customer_properties = {};
      customer_properties["email"] = this.querySelector('input.email').value;
      customer_properties["salutation"] = this.querySelector('select.salutation').value;
      customer_properties["first_name"] = this.querySelector('input.first-name').value;
      customer_properties["last_name"] = this.querySelector('input.last-name').value;
      customer_properties["language"] = document.querySelector('html').getAttribute('lang');

      const options = {
        method: 'POST',
        body: JSON.stringify({
          customer_properties
        })
      };

      const callAPI = async () => {
        let response, data;
        try {
          response = await fetch('https://moynat-scripts.netlify.app/.netlify/functions/new-signup', options);
          data =  await response.json();
          if (data.pass == true) {
            this.style.pointerEvents = "none";
            this.collapseForm();
            this.querySelector('.success-tick').style.display = 'block';
            const className = '.' + this.classList[0] + '.success-message';    
            document.querySelector(className).style.display = 'block';
            this.classList.add('submitted');
          } else {
            const submitError = this.querySelector('.submit-error');
            submitError.textContent = submitError.getAttribute('data-err-msg');
            submitBtn.disabled = false;
          }
        }
        catch(e) {
          console.error(e);
          const submitError = this.querySelector('.submit-error');
          submitError.textContent = submitError.getAttribute('data-err-msg');
          submitBtn.disabled = false;
        }
      }

      callAPI();

    } else {
      console.log('Form Not Valid')
    }
  }

}
customElements.define('moynat-form', moynatForm);
